import { has } from 'lodash'
import { notify } from 'utils'
import store from 'vx/store'

/**
 * Before each route we determine if the user has the necessary permissions to access the page
 * they are trying to get to.
 */
export default (to, from, next, user) => {
  if (has(to.meta, 'modules')) {
    if (to.meta.modules.includes('billboard') && !store.state.clientConfig.client_config.modules.billboard_module) {
      notify.error('You do not have the necessary permission to perform this action.')
      next({name: 'dashboard', replace: true, query: { src: 'module' }})
    }
    if (to.meta.modules.includes('manager') && !store.state.clientConfig.client_config.modules.manager_module) {
      notify.error('You do not have the necessary permission to perform this action.')
      next({name: 'dashboard', replace: true, query: { src: 'module' }})
    }
  }

  if (has(to.meta, 'vlast')) {
    if (to.meta.vlast === false && store.state.clientConfig.client_config.modules.vlast_mode) {
      notify.error('Unavailable when in vlast mode')
      next({name: 'dashboard', replace: true, query: { src: 'module' }})
    }
  }

  if (has(to.meta, 'marketplace')) {
    if (to.meta.marketplace === false && !store.state.clientConfig.client_config.modules.vlast_mode) {
      notify.error('Unavailable when in marketplace mode')
      next({name: 'dashboard', replace: true, query: { src: 'module' }})
    }
  }

  next()
}
